import http from "./http.service";


export const getDashboardData = async (locationId:any, payload: any) => {
    return http.get(`/partner/dashboard/${locationId}`, { params: payload });
}

export const confirmCheckin = async (uniqueCode: string) => {
    return http.put(`/partner/checkins/confirm`, null, { params: { uniqueCode } });
}

